export default __webpack_public_path__ + "static/media/imgpdf.24c2337c.png";